<i18n>
{
  "ru": {
    "cancelled": "Отмена"
  },
  "en": {
    "cancelled": "cancelled"
  }
}
</i18n>
<template>
  <div style="margin: auto; max-width: 1322px;">
    <invoice-details-modal
      v-if="showInvoiceModal"
      :visible.sync="showInvoiceModal"
      :url="invoiceDetailsUrl"
    />
    <el-card>
      <el-form
        :model="filter"
        ref="searchForm"
        @submit.native.prevent="search"
        :rules="filterRules"
      >
        <el-row :gutter="20" class="users-setings-header">
          <el-col :sm="7">
            <el-form-item prop="time">
              <el-date-picker
                v-model="filter.time"
                type="daterange"
                range-separator="|"
                :unlink-panels="true"
                :start-placeholder="$t('from')"
                :end-placeholder="$t('to')"
                align="right"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :sm="4">
            <el-form-item prop="currency_id">
              <el-select v-model="filter.currency_id" :placeholder="$t('currency')">
                <el-option v-for="key in currencies" :key="key" :label="key" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="5">
            <el-form-item prop="billing_status">
              <el-select v-model="filter.billing_status" :placeholder="$t('status')">
                <el-option v-for="(label, key) in statuses" :key="key" :label="label" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :sm="2" class="aligner right" style="height: 60px">
            <el-button native-type="submit" size="small" round type="primary">{{$t('search')}}</el-button>
          </el-col>
          <el-col :sm="3" class="aligner right" style="height: 60px">
            <el-button :disabled="!csvUrl" @click="csvUTF()" size="small" round>CSV (utf-8)</el-button>
          </el-col>
          <el-col :sm="3" class="aligner right" style="height: 60px">
            <el-button :disabled="!csvCPUrl" @click="csvCP()" size="small" round>CSV (cp1251)</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-table
          show-summary
          :summary-method="getSummaries"
          ref="table"
          class="small"
          :data="tableData"
          v-loading="loading"
          style="width: 100%"
        >
          <el-table-column prop="i_date_orig_format" width="130" :label="$t('date_orig')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.i_date_orig_format }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="t_date_orig_format" width="130" :label="$t('batch_date')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.t_date_orig_format }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="i_amt" width="130" :label="$t('field_billing_status')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.i_amt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="t_amt" width="130" :label="$t('field_amount')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.t_amt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="canceled" width="70" :label="$t('cancelled')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.canceled }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="i_id" width="90" :label="$t('invoice_id')">
            <template slot-scope="scope">
              <a
                href="#"
                @click.prevent="showInvoice(scope.row)"
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.i_id}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="t_id" width="120" :label="$t('transaction_id')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.t_id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rrn" width="80" :label="$t('RRN')">
            <template slot-scope="scope">
              <span :data-label="scope.column.label" class="responsive-column">{{ scope.row.rrn }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="i_billing_status" width="80" :label="$t('status')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.i_billing_status }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="po_name" width="160" :label="$t('po_name')">
            <template slot-scope="scope">
              <span
                :data-label="scope.column.label"
                class="responsive-column"
              >{{ scope.row.po_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="po_additional_data" width="160" :label="$t('additional_data')">
            <template slot-scope="scope">
              <span
                  :data-label="scope.column.label"
                  class="responsive-column"
              >{{ Object.values(scope.row.additional_data).join(', ') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          class="aligner right"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next"
          :total="pagination.total"
          @current-change="changePage"
        ></el-pagination>-->
      </el-row>
    </el-card>
  </div>
</template>

<script>
import apiRes from '../../core/apiRes'
import InvoiceDetailsModal from '../invoices/InvoiceDetailsModal'

export default {
  name: 'qrReports',
  components: {
    'invoice-details-modal': InvoiceDetailsModal
  },
  data: () => ({
    filter: {
      // sort_field: 'i_date_orig_format',
      // sort_type: 'DESC',
      time: [],
      currency_id: null,
      billing_status: null
      // page: 1
    },
    filterRules: {
      time: { required: true, trigger: 'blur', message: ' ' }
      // currency_id: { required: true, trigger: 'blur', message: ' ' },
      // billing_status: { required: true, trigger: 'blur', message: ' ' }
    },

    pagination: {
      total: 0,
      pageSize: 25,
      currentPage: 0
    },

    tableData: [],
    invoiceAmount: null,
    transactionAmount: null,
    statuses: [],
    currencies: [],
    csvCPUrl: '',
    csvUrl: '',
    loading: false,
    showInvoiceModal: false,
    invoiceDetailsUrl: ''
  }),
  created() {
    apiRes.get(apiRes.qrReportParams).then(res => {
      res = res.page_vars
      this.currencies = Object.values(res.currency_menu_arr.currency_id).filter((v, i, s) => s.indexOf(v) === i)
      this.statuses = res.select_billing_status
    }).finally(() => { this.loading = false })
  },
  methods: {
    showInvoice(row) {
      this.showInvoiceModal = true
      this.invoiceDetailsUrl = row.i_url
    },
    getSummaries(param) {
      return ['Всего', '', this.invoiceAmount, this.transactionAmount]
    },
    search() {
      this.filter.page = 1
      this.loadReports()
    },
    csvUTF() {
      // var content = this.getCsvContent()
      // var encodedUri = encodeURI(content)
      // var link = document.createElement('a')
      // link.setAttribute('href', 'data:text/csv;charset=utf-8,\uFEFF' + encodedUri)
      // link.setAttribute('download', `${document.title}_UTF8.csv`)
      // link.click()
      // link.remove()

      var link = document.createElement('a')
      link.setAttribute('href', apiRes.baseUrl + this.csvUrl)
      // link.setAttribute('download', `${document.title}_UTF8.csv`)
      link.click()
      link.remove()
    },
    csvCP() {
      var link = document.createElement('a')
      link.setAttribute('href', apiRes.baseUrl + this.csvCPUrl)
      // link.setAttribute('download', `${document.title}_UTF8.csv`)
      link.click()
      link.remove()
    },
    getCsvContent() {
      let table = this.$refs['table']
      return [table.columns.map(c => c.label).join(' ;')]
        .concat(table.data.map(row => table.columns.map(c => row[c.property]).join(';'))).join('\n')
    },
    processResponse(vars) {
      if (vars) {
        // vars.res.records.forEach(r => {
        //   if (r.date_last) {
        //     r.date_last = new Date(parseInt(r.date_last) * 1000).toLocaleString(this.$locale)
        //   }
        //   if (r.date_orig) {
        //     r.date_orig = new Date(parseInt(r.date_orig) * 1000).toLocaleString(this.$locale)
        //   }
        //   r.show = false
        // })

        this.csvCPUrl = vars.url_export_csv_cp1251
        this.csvUrl = vars.url_export_csv
        this.tableData = vars.tr
        this.invoiceAmount = vars.invoice_total_amt
        this.transactionAmount = vars.transaction_total_amt
        // this.pagination = {
        //   total: vars.count,
        //   currentPage: vars.page,
        //   pageSize: vars.count_per_page
        // }
      } else {
        this.tableData = []
        // this.pagination = {}
      }
    },
    parseReports(promise) {
      this.loading = true
      this.tableData = []
      promise.then((data) => {
        this.processResponse(data.page_vars)
        this.loading = false
      }).catch(() => {
        this.$notify.error({
          title: this.$t('error'),
          message: ''
        })
        this.loading = false
      })
    },
    loadReports() {
      this.$refs['searchForm'].validate((valid) => {
        if (this.filter.time && this.filter.time.length === 2) {
          this.loading = true
          const request = {}

          const parts = this.filter.time.map(d => d.toISOString().slice(0, 10))
          request.date_from = parts[0]
          request.date_to = parts[1]
          request.currency_id = this.filter.currency_id
          request.billing_status = this.filter.billing_status
          this.parseReports(apiRes.post(apiRes.qrReports, request))
        }
      })
    },
    changePage(newPage) {
      // this.filter.page = newPage
      // this.loadReports()
    },
    changeSort({ column, prop, order }) {
      // this.filter.sort_field = prop
      // this.filter.sort_type = order === 'ascending' ? 'ASC' : 'DESC'
      // this.loadReports()
    }
  }
}
</script>
<style>
.el-table__footer-wrapper {
  font-weight: bold;
}
.el-table__footer-wrapper tr td:first-child .cell {
  text-align: left;
}
</style>
